import BbProxy from "@/proxies/BbProxy";

class DemoSignedProxy extends BbProxy {
  constructor() {
    super("app/creative/demos/signed");
  }
}

export default DemoSignedProxy;
